import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { colors } from '../../../constants';
import { loginButtonStyles, loadingSpinnerStyles } from '../../../constants/manualLogin';

/**
 * LoginButton Component
 * Submit button with loading state
 */
const LoginButton = ({ loading }) => {
  return (
    <Button type="submit" fullWidth variant="contained" disabled={loading} sx={loginButtonStyles}>
      {loading ? <CircularProgress size={20} sx={loadingSpinnerStyles} /> : 'Login'}
    </Button>
  );
};

export default LoginButton;
